import React from "react";
import { Route, Routes } from "react-router-dom";

import OverNightGuestPage from "~v2/pages/OvernightGuestPages/OvernightGuestPage";
import OverNightGuestFormPage from "~v2/pages/OvernightGuestPages/OverNightGuestFormPage";
import OvernightGuestViewPage from "~v2/pages/OvernightGuestPages/OverNightGuestViewPage";

import DaytimeTouristPage from "~v2/pages/DaytimeTouristPages/DaytimeTouristPage";
import DaytimeTouristFormPage from "~v2/pages/DaytimeTouristPages/DaytimeTouristFormPage";
import DaytimeTouristViewPage from "~v2/pages/DaytimeTouristPages/DaytimeTouristViewPage";

import InboundMonitoringPage from "~v2/pages/InboundMonitoringPages/InboundMonitoringPage";
import InboundMonitoringFormPage from "~v2/pages/InboundMonitoringPages/InboundMonitoringFormPage";
import InboundMonitoringViewPage from "~v2/pages/InboundMonitoringPages/InboundMonitoringViewPage";

import TourOperatorPage from "~v2/pages/TourOperatorPages/TourOperatorPage";
import TourOperatorFormPage from "~v2/pages/TourOperatorPages/TourOperatorFormPage";
import TourOperatorViewPage from "~v2/pages/TourOperatorPages/TourOperatorViewPage";

import MICEreportPage from "~v2/pages/MICEReportPages/MICEreportPage";
import MICEreportViewPage from "~v2/pages/MICEReportPages/MICEreportViewPage";
import MICEreportFormPage from "~v2/pages/MICEReportPages/MICEreportFormPage";

import FAQPage from "~v2/pages/FAQ-TRE/FAQPage";
import Contacts from "~v2/pages/Contacts/Contacts";
import HomePage from "~v2/pages/HomepageTRE/HomepageTRE";
import NotificationTRE from "../pages/NotificationTRE/NotificationTRE";
import NotificationTREView from "../pages/NotificationTRE/NotificationTREView";

const TreRoutes = () => {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<HomePage />} />

      {/* Notification */}
      <Route path="/notification" element={<NotificationTRE />} />
      <Route path="/notification/:id" element={<NotificationTREView />} />

      {/* Overnight Guest Module */}
      <Route path="overnight-guest" element={<OverNightGuestPage />} />
      <Route path="overnight-guest/:id" element={<OverNightGuestFormPage />} />
      <Route
        path="overnight-guest/view/:id"
        element={<OvernightGuestViewPage />}
      />

      {/* Daytime Tourist Module */}
      <Route path="daytime-tourist" element={<DaytimeTouristPage />} />
      <Route path="daytime-tourist/:id" element={<DaytimeTouristFormPage />} />
      <Route
        path="daytime-tourist/view/:id"
        element={<DaytimeTouristViewPage />}
      />

      {/* Mice Report Module */}

      <Route path="mice-reports" element={<MICEreportPage />} />
      <Route path="mice-reports/:date" element={<MICEreportFormPage />} />
      <Route path="mice-reports/view/:date" element={<MICEreportViewPage />} />

      {/* Inbound Monitoring Module */}
      <Route path="inbound-monitoring" element={<InboundMonitoringPage />} />
      <Route
        path="inbound-monitoring/:id"
        element={<InboundMonitoringFormPage />}
      />
      <Route
        path="inbound-monitoring/view/:id"
        element={<InboundMonitoringViewPage />}
      />

      {/* Tour Operator Module */}
      <Route path="tour-operator" element={<TourOperatorPage />} />
      <Route path="tour-operator/:id" element={<TourOperatorFormPage />} />
      <Route path="tour-operator/view/:id" element={<TourOperatorViewPage />} />

      {/* Other Module */}
      <Route path="faq" element={<FAQPage />} />
      <Route path="contacts" element={<Contacts />} />
    </Routes>
  );
};

export default TreRoutes;
